
import { Call } from "@mui/icons-material";
import {
  Box,
 
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
 
  styled,
  Typography,
} from "@mui/material";
import React from "react";
import Gene20Box from "../../Gene20Box/Gene20Box";

export default function PhoneContact() {
  const contactDetails = [
    { name: "capetown", number: "+ 27 63 185 5985" },
    { name: "johanesBurg", number: "+ 27 61 305 5464" },
  ];
  const Gene20BorderBox = styled(Box)`
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 10px;
    padding: 1rem;
    margin: 0.2rem;
  `;

  return (
    <Gene20Box px={1.5} marginTop="1rem">
      <Typography
        align="left"
        color="primary"
        sx={{ textTransform: "uppercase" }}
      >
        contact us
      </Typography>
      <Gene20BorderBox
        component={List}
        display="flex"
        justifyContent="center"
        alignItems="right"
        flexWrap="wrap"
        lineHeight={1}
      
      >
        {contactDetails.map((item, index) => (
          <ListItem
            key={index}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexWrap="wrap"
            // fontSize={size.sm}
            px={1.5}
            marginTop="3"
            lineHeight={1}
            padding="1rem"
          >
            <ListItemIcon>
              <Call />
            </ListItemIcon>
            <ListItemText>
              <Typography
                color="secondary"
                sx={{ textTransform: "uppercase" }}
                variant="body2"
              >
                call
              </Typography>
            </ListItemText>
            <ListItemText>
              <Typography color="secondary" variant="body2">
                {item.number}
              </Typography>
            </ListItemText>
          </ListItem>
        ))}
      </Gene20BorderBox>
    </Gene20Box>
  );
}
